export const formatTourHighlights = (raw = "") => {
  if (!raw.trim()) return ""

  const lines = raw
    .split(/\s*;\s*|\s+-\s+/)
    .map((part) => part.trim())
    .filter(Boolean)

  if (lines.length > 1) return lines.join("\n")

  return raw
    .split("|")
    .map((part) => part.trim())
    .filter(Boolean)
    .join("\n")
}

export const parseTourName = (tourName: string) => {
    let _tourName = tourName || ""
    const providerCodes = ['DVT', 'SGT', 'TNT']
    for (let i = 0; i < providerCodes.length; i++) {
      const providerCode = providerCodes[i];
      const cases = [`${providerCode}`, `${providerCode}.`, `${providerCode} `]
      for (let u = 0; u < cases.length; u++) {
        const c = cases[u];
        _tourName = _tourName.replace(c, '')
      }
    }
    return _tourName
  }